import { render, staticRenderFns } from "./PostAlignment.vue?vue&type=template&id=54628b10&"
import script from "./PostAlignment.vue?vue&type=script&lang=js&"
export * from "./PostAlignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports